import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig, TreeNode } from 'primeng/api';
import { AlertUtil } from '../utils/alert-util';
import { IAttivita } from '../interfaces/IAttivita';
import * as Enum from '../utils/enums';
import { Loading } from '../utils/loading';
import { IPagamento } from '../interfaces/IPagamento';
import { IPagamentoAttivita } from '../interfaces/IPagamentoAttivita';
import { RequestBuilder } from '../classes/request-builder';
import { PaymentService } from '../services/payment.service';
import { finalize } from 'rxjs/operators';
import * as Moment from 'moment';

@Component({
  selector: 'app-payment-modal',
  templateUrl: './payment-modal.component.html',
  styleUrls: ['./payment-modal.component.css']
})
export class PaymentModalComponent implements OnInit {

  listaAttivita: IAttivita[] = [] //list from services
  listaAttivitaDropDown: IAttivita[] = [] //list for dropdown
  listaAttivitaSelected: IAttivita[] = []; //list item selected


  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html
  L = Loading                     //export loading for html
  it: any //object for italian calendar

  paymentForm: FormGroup
  totaleImporto: number = 0
  amountWarning: boolean

  attivitaSelected: IAttivita
  importoSelected: number
  disabled: boolean = true
  invalid: boolean = false

  uploadedFiles: any[] = [];          //for upload file
  nameAllegato: string = null         //name allegato


  constructor(private formBuilder: FormBuilder, private ref: DynamicDialogRef,
    private config: DynamicDialogConfig, private alertUtil: AlertUtil, private paymentService: PaymentService) {

    this.listaAttivitaDropDown = this.config.data.listaAttivita
    this.listaAttivita = this.config.data.listaAttivita

    //build form group
    this.paymentForm = this.formBuilder.group({
      'importo': ['', Validators.required],
      'oggetto': ['', Validators.required],
      'categoriaSOA': [''],
      'note': ['', ''],
      'dataPagamento': ['', Validators.required]

    })

    // build italian options for calendar
    this.it = {
      firstDayOfWeek: 1,
      dayNames: ["domenica", "lunedì", "martedì", "mercoldì", "giovedì", "venerdì", "sabato"],
      dayNamesShort: ["do", "lu", "ma", "me", "gio", "ve", "sa"],
      dayNamesMin: ["D", "L", "m", "M", "G", "V", "S"],
      monthNames: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"],
      monthNamesShort: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
      today: 'Oggi',
      clear: 'Cancella'
    }

  }

  ngOnInit() { }

  // convenience getter for easy access to form fields
  get form() { return this.paymentForm.controls; }


  /**
   * on change event dropDown
   * @param event 
   */
  onChangeAttivita(event: any) {
    this.attivitaSelected = event.value
    this.disabled = false
  }

  /**
   * onClick del tasto Add
   */
  onAddButtonClick() {
    /**se per l'attività selezionata l'importo  non è stato inserito il campo viene reso invalid*/
    if (this.importoSelected == 0 || this.importoSelected == null) {
      this.invalid = true
    } else {
      this.attivitaSelected.Importo = this.importoSelected
      this.listaAttivitaSelected.push(this.attivitaSelected)

      this.importoSelected = null
      this.invalid = false
      this.disabled = true
      this.getAmountListaAttivita();

      /** rimuovo l'attività selezionata  dal menu a tendina*/
      let attivitaList: IAttivita[] = []
      this.listaAttivitaDropDown.forEach(attivita => {
        if (attivita.Id != this.attivitaSelected.Id) {
          attivitaList.push(attivita)
        }
      })
      this.listaAttivitaDropDown = attivitaList
    }
  }

  /**
   * OnChange dell'input text
   */
  onChangeInput() {
    if (this.importoSelected == 0 || this.importoSelected == null) {
      this.invalid = true
    } else {
      this.invalid = false
    }
  }

  /**
   * actionButtonClick: event from data table
   * @param attivita 
   */
  onActionButtonClicked(attivita: IAttivita) {
    this.removeAttivitaFromList(attivita)
    this.getAmountListaAttivita();

    /**aggiungo l'attività rimossa dalla tabella alla dropDown */
    let list: IAttivita[] = []
    this.listaAttivita.forEach(attivita => {
      if (!this.listaAttivitaSelected.find(att => att.Id === attivita.Id)) {
        list.push(attivita)
      }
    })
    this.listaAttivitaDropDown = list
    this.disabled = false
    this.invalid = false
  }

  /**
  * remove attivita from lista selected
  * @param event 
  */
  removeAttivitaFromList(attivita: IAttivita) {
    const index: number = this.listaAttivitaSelected.indexOf(attivita);
    if (index !== -1) {
      this.listaAttivitaSelected.splice(index, 1);
    }
  }

  /**
   * get TotalAmount from listaSelected
   * @param event 
   */
  getAmountListaAttivita() {
    this.totaleImporto = 0
    this.listaAttivitaSelected.forEach(attivita => {
      this.totaleImporto = (this.totaleImporto + attivita.Importo)
    })
    this.amountWarning = false
  }

  /**
   * onSubmit Form
   */
  onSubmit() {
    if (this.totaleImporto != null && this.totaleImporto === this.paymentForm.controls["importo"].value) {
      /**
       * creazione del payload
       */
      let newPagamento: IPagamento = this.createPagamentoObj();
      this.callSavePagamento(newPagamento);

    } else {
      /**
       * messaggio di errore
       */
      if (this.paymentForm.valid && this.listaAttivitaSelected.length > 0) {
        this.alertUtil.showErrorAlert("LBL_PAYMENT_SAVE_ERROR", null, null, null, () => {
        })
      }
    }
  }

  /**
   * create obj pagamento for save
   */
  createPagamentoObj() {
    let Importo = this.paymentForm.controls["importo"].value;
    let Oggetto = this.paymentForm.controls["oggetto"].value;
    let categoriaSOA = this.paymentForm.controls["categoriaSOA"].value;
    let Data = this.paymentForm.controls["dataPagamento"].value;
    let rel_PagamentoAttivita: IPagamentoAttivita[] = [];
    this.listaAttivitaSelected.forEach(attivita => {
      let relPag: IPagamentoAttivita = {
        Importo: attivita.Importo,
        Attivita: {
          Id: attivita.Id
        }
      };
      rel_PagamentoAttivita.push(relPag);
    });
    let newPagamento: IPagamento = {
      Oggetto: Oggetto,
      Categoria_SOA: categoriaSOA,
      Importo: Importo,
      Data_esecuzione: Moment(Data).format("YYYY-MM-DDTHH:mm:ss"),
      rel_PagamentoAttivita: rel_PagamentoAttivita
    };
    return newPagamento;
  }

  /**
   * call service save/pagamento
   * @param newPagamento obj pagameto
   */
  callSavePagamento(newPagamento: IPagamento) {
    let reqBuilder = new RequestBuilder(newPagamento);
    this.paymentService.save(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false;
    })).subscribe(response => {
      if (response.data) {
        if (this.uploadedFiles && this.uploadedFiles.length > 0) {
          let pagamentoSaved: IPagamento = response.data
          this.callSaveAllegato(pagamentoSaved)
        } else {
          this.pagamentoSaveSuccesMessage()
        }
      }
      else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code;
        this.alertUtil.showErrorAlert(errorKey);
        console.log("ERROR: " + response.error.Stack);
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message });
      }
    }, error => {
      let errorKey = "LBL_HTTP_ERROR_0";
      if (error.status) {
        errorKey = "LBL_HTTP_ERROR_" + error.status;
      }
      this.alertUtil.showErrorAlert(errorKey);
    });
  }

  /**
   * click button allega doc
   * @param event file
   * @param question question selected
   */
  uploadClick(event: any, upload: any) {
    this.uploadedFiles = []
    upload.clear()
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }
    this.nameAllegato = this.uploadedFiles[0].name
  }

  /**
   * call service for save allegato
   */
  callSaveAllegato(pagamentoSaved: IPagamento) {
    Loading.isLoading = true
    this.paymentService.uploadAllegatoPagamento(this.uploadedFiles[0], this.uploadedFiles[0].name, pagamentoSaved.Id.toString()).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) { //return all allegatoObj
          this.pagamentoSaveSuccesMessage();
        } else {
          this.alertUtil.showErrorAlert("LBL_ERROR_300")
        }
      })

  }

  /**
   * save success
   */
  pagamentoSaveSuccesMessage() {
    this.alertUtil.showAlert("LBL_PAGAMENTO_SAVE_SUCCESS", null, null, null, () => {
      this.ref.close();
    });
  }
}

